'use strict';

const { isEmpty, get } = require('lodash');

const $cache = {
    saveCommentBtn: $('.fa-user-agent-comment-save-btn'),
    comments: $('input[name="userAgentComment"]'),
};

const submitCrcComment = () => {
    $cache.saveCommentBtn.on('click', function (e) {
        e.preventDefault();

        const $this = $(this);
        const url = $this.data('url');

        if (!isEmpty(url)) {
            const formData = new FormData();
            const notes = [];
            $cache.comments.each((_, input) => {
                const $el = $(input);
                const uuid = $el.attr('id')?.split('-')[1];
                notes.push({ uuid, note: $el.val() });
            });

            formData.append('notes', JSON.stringify(notes));

            const csrfToken = $this.parent().find('#crc-csrf');
            formData.append('csrf_token', csrfToken.val());

            const objectData = {};
            formData.forEach(function (value, key) {
                objectData[key] = value;
            });

            $.spinner().start();

            $.ajax({
                type: 'POST',
                url: url,
                data: objectData,
                success(response) {
                    if (get(response, 'success', '')) {
                        $cache.comments.each((_, input) => {
                            $(input).val('');
                        });
                    }
                    $.spinner().stop();
                },
                error() {
                    $.spinner().stop();
                },
            });
        }
    });
};

module.exports = { submitCrcComment };
